import { Link } from 'react-router-dom';
import './StaticPages.css';

export default function Privacy() {
  return (
    <div className="static-page">
      <div className="static-container">
        <Link to="/register" className="static-back">&larr; Back to Sign Up</Link>
        <h1>Privacy Policy</h1>
        <p className="static-date">Last updated: July 30, 2026</p>

        <section>
          <h2>1. Information We Collect</h2>
          <p>We collect information you provide when creating an account, including your name, email address, username, and phone number. We also collect transaction data related to your orders and payments.</p>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <p>Your information is used to:</p>
          <ul>
            <li>Provide, maintain, and improve our SMM services</li>
            <li>Process transactions and send order confirmations</li>
            <li>Communicate with you regarding your account and support requests</li>
            <li>Detect and prevent fraudulent activity</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>3. Data Sharing</h2>
          <p>We do not sell your personal information. We may share data with third-party service providers who assist in delivering our services (e.g., payment processors, API providers). These parties are contractually obligated to protect your data.</p>
        </section>

        <section>
          <h2>4. Data Retention</h2>
          <p>We retain your account information for as long as your account is active. After account deletion, we may retain certain data as required by law or for legitimate business purposes.</p>
        </section>

        <section>
          <h2>5. Security</h2>
          <p>We implement reasonable security measures to protect your data. However, no method of transmission over the Internet is 100% secure. You use the Service at your own risk.</p>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <p>You may update or correct your account information through your profile settings. You may request account deletion by contacting support.</p>
        </section>

        <section>
          <h2>7. Cookies</h2>
          <p>We use essential cookies for authentication and security. No tracking or advertising cookies are used.</p>
        </section>

        <section>
          <h2>8. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify users of material changes via email or through the platform.</p>
        </section>

        <section>
          <h2>9. Contact</h2>
          <p>If you have questions about this Privacy Policy, please contact our support team.</p>
        </section>
      </div>
    </div>
  );
}
